export const GET_BRANCH = 'GET_BRANCH'
export const GET_BRANCHES_TASK_ARE_ASSIGNED_TO = 'GET_BRANCHES_TASK_ARE_ASSIGNED_TO'
export const GET_ALL_BRANCHES = 'GET_ALL_BRANCHES'
export const UPDATE_BRANCH = 'UPDATE_BRANCH'
export const DELETE_BRANCH = 'DELETE_BRANCH'
export const CREATE_BRANCH = 'CREATE_BRANCH'
export const RESET_BRANCH = 'RESET_BRANCH'
export const GET_BRANCHES_FOR_SELECT = 'GET_BRANCHES_FOR_SELECT'
